import * as React from "react"
import { FrameWithMotion } from "../render"
import { MotionValue } from "framer-motion"

interface PageContainerProps {
    x: number
    y: number
    width: number
    height: number
    effect: { [key: string]: MotionValue } | undefined
    children?: React.ReactNode
}

export function PageContainer({ x, y, width, height, children, effect }: PageContainerProps) {
    return (
        <FrameWithMotion left={x} top={y} width={width} height={height} background={"transparent"} preserve3d={true}>
            <FrameWithMotion
                width={"100%"}
                height={"100%"}
                preserve3d={false}
                key={effect ? Object.keys(effect as {}).join("") : ""}
                style={effect}
                background={"transparent"}
            >
                {children}
            </FrameWithMotion>
        </FrameWithMotion>
    )
}
